"use client";

import React, { useState } from "react";
import Image from "next/image";
import styles from "./FilterGridSection.module.css";

const BRAND = "#F48428";

export default function FilterGridSection({ dynamicData }) {
  const [activeCategory, setActiveCategory] = useState(0);

  if (!dynamicData) return null;

  const { tag, title, subtitle, categories } = dynamicData;
  const currentCategory = categories?.[activeCategory] || categories?.[0];

  const getImageUrl = (url) => {
    if (!url || typeof url !== "string") return "";
    if (url.startsWith("data:") || url.startsWith("blob:")) return url;
    
    const apiUrl = (process.env.NEXT_PUBLIC_API_URL || process.env.NEXT_PUBLIC_API_BASE_URL || '').replace(/\/api\/?$/, '').replace(/\/$/, '') || "";
    
    if (url.includes("/uploads/")) {
      const cleanPath = url.substring(url.indexOf("/uploads/"));
      return `${apiUrl}${cleanPath}`;
    }
    
    if (url.startsWith("uploads/") || url.startsWith("/uploads/")) {
      const cleanPath = url.startsWith("/") ? url : `/${url}`;
      return `${apiUrl}${cleanPath}`;
    }
    
    if (url.startsWith("http")) return url;
    return url;
  };

  return (
    <section className={styles.section}>
      <div className="container">
        <div className={styles.header}>
          {tag && <div className={styles.eyebrow}>{tag}</div>}
          <h2 className={styles.title}>{title}</h2>
          {subtitle && <p className={styles.subtitle}>{subtitle}</p>}
        </div>

        <div className={styles.gridContainer}>
          {/* Sidebar */}
          <aside className={styles.sidebar}>
            {categories?.map((cat, idx) => (
              <button
                key={idx}
                className={`${styles.navBtn} ${activeCategory === idx ? styles.active : ""}`}
                onClick={() => setActiveCategory(idx)}
              >
                {cat.name}
              </button>
            ))}
          </aside>

          {/* Grid Area */}
          <div className={styles.contentArea}>
            <div className={styles.grid}>
              {currentCategory?.items?.map((item, idx) => (
                <div key={idx} className={styles.card}>
                  <div className={styles.iconBox}>
                    {item.icon && typeof item.icon === "string" && (item.icon.includes("/") || item.icon.startsWith("http")) ? (
                      <Image src={getImageUrl(item.icon)} alt={item.name} width={40} height={40} style={{ objectFit: "contain" }} />
                    ) : (
                      <i className={(item.icon && typeof item.icon === "string") ? item.icon : "fa-solid fa-microchip"}></i>
                    )}
                  </div>
                  <h4 className={styles.itemName}>{item.name}</h4>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
